import { createVNode as _createVNode, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { useAgentDiscountCodes } from '@/composables/useAgentDiscountCodes'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy } from '@/config/agentWizardSteps'
import AgentOfferFields from '@/view/ai/AgentOfferFields.vue'
import AgentChooseSection from '@/view/ai/agentWizard/steps/AgentChooseSection.vue'
import AgentMessageField from '@/view/ai/agentWizard/steps/AgentMessageField.vue'


export default {
  __name: 'AgentStepWinback',
  setup(__props) {

const wizard = injectWizard()
const section = wizard.data.winback
const codes = useAgentDiscountCodes()

const copy = key => sectionCopy(key, wizard.data, wizard.ctx)
const example = reply =>
  `How the agent might carry on if they reply: "${reply}" ${wizard.ctx.storeName} answers in your voice and points them to your menu.`

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AgentChooseSection, { "step-key": "winback" }),
    (_unref(section).enabled)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('winback.quiet'))), {
            default: _withCtx(() => [
              _createVNode(NumberStepper, {
                modelValue: _unref(section).lost_window_days,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(section).lost_window_days) = $event)),
                name: "Treat a customer as lost after (days)",
                description: "Lost customers get the lost message below.",
                min: 1
              }, null, 8, ["modelValue"]),
              _createVNode(ToggleRow, {
                modelValue: _unref(section).slipping_enabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(section).slipping_enabled) = $event)),
                title: "Also text slipping customers",
                description: "Regulars who are well past their usual gap between orders. Catching them early works better than waiting until they are lost."
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('winback.message'))), {
            default: _withCtx(() => [
              _createVNode(AgentMessageField, {
                modelValue: _unref(section).lost_message,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(section).lost_message) = $event)),
                label: "Message to lost customers",
                example: example('Sure, what is on this week?')
              }, null, 8, ["modelValue", "example"]),
              (_unref(section).slipping_enabled)
                ? (_openBlock(), _createBlock(AgentMessageField, {
                    key: 0,
                    modelValue: _unref(section).slipping_message,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(section).slipping_message) = $event)),
                    label: "Message to slipping customers",
                    example: example('Yes please, send the menu.')
                  }, null, 8, ["modelValue", "example"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 16),
          _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('winback.offer'))), {
            default: _withCtx(() => [
              _createVNode(AgentOfferFields, {
                enabled: _unref(section).offer_enabled,
                "onUpdate:enabled": _cache[4] || (_cache[4] = $event => ((_unref(section).offer_enabled) = $event)),
                "discount-code-id": _unref(section).discount_code_id,
                "onUpdate:discountCodeId": _cache[5] || (_cache[5] = $event => ((_unref(section).discount_code_id) = $event)),
                codes: _unref(codes)
              }, null, 8, ["enabled", "discount-code-id", "codes"])
            ]),
            _: 1
          }, 16)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

}